var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('A',{staticStyle:{"color":"inherit","text-decoration":"underline","font-style":"italic"},attrs:{"HREF":_vm.glTarget,"target":"GPXPDoc"}},[_vm._v(_vm._s(_vm.glText))])}
var staticRenderFns = []

export { render, staticRenderFns }